import React, { useState } from "react";
import { ExercisePaymentDetailsReportDto } from "../../../../api/Esop";
import { MultiSelectV2 } from "../../../../components/shared/MultiSelectV2";
import { Input, Label } from "../../../../components/shared/InputField";
import {
  ButtonPrimary,
  ButtonPrimary1,
  HStack,
  VStack,
} from "../../../../components/utils";

type Props = {
  params: ExercisePaymentDetailsReportDto;
  onClose: () => void;
  onExport: (params: ExercisePaymentDetailsReportDto) => void;
};

const statuses = [
  "PAYMENT_PENDING",
  "PENDING",
  "PROCESSING",
  "SUCCESS",
  "FAILED",
  "PAYMENT_FAILED",
  "REJECTED",
  "NOT_SUBMITTED",
].map((value) => ({ value, label: value.replace(/_/g, " ") }));
const types = ["exercise price", "tax price"].map((value) => ({ value }));

export default function PaymentDetailsExportReportDialog({
  params,
  onClose,
  onExport,
}: Props) {
  const [reportDto, setReportDto] =
    useState<ExercisePaymentDetailsReportDto>(params);

  return (
    <div className="w-[600px] max-w-full mx-auto bg-white rounded-lg">
      <div className="p-8 text-lg font-medium border-b">
        <h6 className="flex justify-between">
          Export Payment Details
          <span className="cursor-pointer" onClick={onClose}>
            X
          </span>
        </h6>
      </div>
      <VStack className="w-full gap-5 px-8 py-4">
        <p className="text-sm text-gray-500">
          Select the filters to export specific payment details. If no filters
          are selected, all payment details will be exported.
        </p>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <VStack className="gap-1">
            <Label>Payment From Date</Label>
            <Input
              type="date"
              value={reportDto.paymentFromDate || ""}
              max={reportDto.paymentToDate}
              onChange={(e) =>
                setReportDto((current) => ({
                  ...current,
                  paymentFromDate: e.target.value || undefined,
                }))
              }
            />
          </VStack>
          <VStack className="gap-1">
            <Label>Payment To Date</Label>
            <Input
              type="date"
              value={reportDto.paymentToDate || ""}
              min={reportDto.paymentFromDate}
              onChange={(e) =>
                setReportDto((current) => ({
                  ...current,
                  paymentToDate: e.target.value || undefined,
                }))
              }
            />
          </VStack>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <VStack className="gap-1">
            <Label>Payment Status</Label>
            <MultiSelectV2
              multiple
              placeholder="All payment statuses"
              optionValues={reportDto.paymentStatuses || []}
              handleSelection={(paymentStatuses) =>
                setReportDto((current) => ({
                  ...current,
                  paymentStatuses: paymentStatuses.length
                    ? paymentStatuses
                    : undefined,
                }))
              }
              options={statuses}
              _className="min-h-10"
            />
          </VStack>
          <VStack className="gap-1">
            <Label>Payment Type</Label>
            <MultiSelectV2
              multiple
              placeholder="All payment types"
              optionValues={reportDto.paymentTypes || []}
              handleSelection={(paymentTypes) =>
                setReportDto((current) => ({
                  ...current,
                  paymentTypes: paymentTypes.length ? paymentTypes : undefined,
                }))
              }
              options={types}
              _className="min-h-10"
            />
          </VStack>
        </div>
        <HStack className="justify-between gap-3 pt-3 mt-20">
          <ButtonPrimary1 onClick={onClose}>Cancel</ButtonPrimary1>
          <ButtonPrimary onClick={() => onExport(reportDto)}>
            Export
          </ButtonPrimary>
        </HStack>
      </VStack>
    </div>
  );
}
